import BaseListPresenter from "../../../base/BaseListPresenter";
import DialogConfirmation from "../components/DialogConfirmation";

class InterviewListPagePresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
  }

  componentDidMount() {
    this.init();
    return this.getObjects();
  }

  init() {
    const user = this.view.getCurrentUser();
    this.limit = 20;
    this.where = {
      coordinator: {
        id: user.id,
      },
    };
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined;
    this.sort = { created: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();

      const [online, walkIn, reprocess] = await Promise.all([
        this.findObjectUseCase.execute("online_applicants", query),
        this.findObjectUseCase.execute("walkIn_applicants", query),
        this.findObjectUseCase.execute("reprocess_applicants", query),
      ]);

      this.objects = [...online, ...walkIn, ...reprocess];
      this.objects.sort((a, b) => new Date(b.created) - new Date(a.created));
      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);

      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    } finally {
      this.progress = false;
    }
  }

  async getOnlineApplicants() {
    const collection = "online_applicants";
    const query = this.createQuery();

    try {
      this.showProgress();
      this.findObjectUseCase.abort();

      const objects = await this.findObjectUseCase.execute(collection, query);

      this.objects = objects;
      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);

      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  async getWalkInApplicants() {
    const collection = "walkIn_applicants";
    const query = this.createQuery();

    try {
      this.showProgress();
      this.findObjectUseCase.abort();

      const objects = await this.findObjectUseCase.execute(collection, query);

      this.objects = objects;
      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);

      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  async getReprocessApplicants() {
    const collection = "reprocess_applicants";
    const query = this.createQuery();

    try {
      this.showProgress();
      this.findObjectUseCase.abort();

      const objects = await this.findObjectUseCase.execute(collection, query);

      this.objects = objects;
      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);

      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  onChangeStatus(value, schema) {
    this.reset();
    this.filter = {
      ...this.filter,
      status: { $regex: value, $options: "i" },
    };
    this.applyFilters();
  }

  onChangePosition(value, schema) {
    this.reset();
    this.filter = {
      ...this.filter,
      positionApplied: { $regex: value, $options: "i" },
    };
    this.applyFilters();
  }

  onChangeReferenceNo(value, schema) {
    this.reset();
    this.filter = {
      ...this.filter,
      referenceNumber: { $regex: value, $options: "i" },
    };
    this.applyFilters();
  }

  onChangeDate(value, schema) {
    this.reset();
    this.filter = {
      ...this.filter,
      updated: { $regex: value, $options: "i" },
    };
    this.applyFilters();
  }

  applyFilters() {
    this.getObjects();
  }
}

export default InterviewListPagePresenter;
